import { GameItem } from 'dt-common/generated/prisma/client';
import { ApiErrorMessage } from 'dt-common/types/ApiErrorMessages';
import mutationCavernsTravel from '~/graphql/caverns/mutationCavernsTravel';
import { GraphQlRequestError } from '~/graphql/graphqlClient';
import { logError } from '~/logger';
import text from '~/text';
import messages, { CavernsStoreMessage } from '../messages';

export default async function cavernsTravel(
  {
    playerId,
    game_submode,
    direction,
    survivingWhiteUnits,
    setPendingCavernsTravel,
    setCavernsData,
    setLootPickedUp,
    emit,
    proxyToWorker,
    onMissingCavernsRunData,
  }: {
    playerId: string | null;
    game_submode: string;
    direction: string;
    survivingWhiteUnits: any[];
    setPendingCavernsTravel: (val: boolean) => void;
    setCavernsData: (val: any) => void;
    setLootPickedUp: (data: { gold: number; pd: number; items: GameItem[]; }) => void;
    emit: (message: CavernsStoreMessage, data?: any) => void;
    proxyToWorker: (message_name: string, message_data: any) => void;
    onMissingCavernsRunData: () => void;
  }
) {
  if (!playerId) {
    throw new Error('Player ID is required');
  }

  try {
    // Disable ability executor during travel to prevent race conditions
    proxyToWorker('disable_unit_actions', null);

    const data = await mutationCavernsTravel({
      playerId,
      game_submode,
      direction,
      survivingWhiteUnits,
    });

    setPendingCavernsTravel(false);

    if (data?.caverns_data) {
      setCavernsData(data.caverns_data);
    }

    // Travel auto-loots the old room; keep the UI/store in sync.
    setLootPickedUp({ gold: data.gold, pd: data.pd, items: data.items as GameItem[] });
    emit(messages.TOTAL_LOOT_PICKED_UP, { gold: data.gold, pd: data.pd, items: data.items });

    emit(messages.CAVERNS_TRAVEL_SUCCESS, data);
    proxyToWorker('caverns_travel_success', data);
  } catch (err) {
    setPendingCavernsTravel(false);

    if (err instanceof GraphQlRequestError) {
      // Preserve the legacy behavior: if the server says the run is missing, tear down.
      if (err.errors.find((error) => error.message === ApiErrorMessage.NO_CURRENT_RUN_FOUND)) {
        onMissingCavernsRunData();
        return;
      }

      if (err.errors.find((error) => error.message === 'caverns_enemy_blocking')) {
        $addMessageLogMessage(text('ui.enemies_in_play'), 0xff0000);
      }
    }

    logError(err, {
      module: 'CavernsStore/handlers',
      func: 'cavernsTravel',
      playerId,
      game_submode,
      direction,
    });
  } finally {
    proxyToWorker('enable_unit_actions', null);
  }
}


